import {
    GETMANUALSETTLEMENT_SUCCESS,
    GETMANUALSETTLEMENT_FAILED,
    RESET_GETMANUALSETTLEMENT,
    LOADING_GETMANUALSETTLEMENT,
    NETWORK_ERROR_GETMANUALSETTLEMENT
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetgetManualSettlement = () => {
    return { type: RESET_GETMANUALSETTLEMENT };
};

const getManualSettlement = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETMANUALSETTLEMENT });
    await partnerServices
        .post("manualSettingList1", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(getManualSettlementsuccess(res.data));
                    break;
                default:
                    dispatch(getManualSettlementFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_GETMANUALSETTLEMENT,
                payload: err
            });
        });
};
function getManualSettlementsuccess(data) {
    return {
        type: GETMANUALSETTLEMENT_SUCCESS,
        payload: data
    };
}
function getManualSettlementFailed(data) {
    return {
        type: GETMANUALSETTLEMENT_FAILED,
        payload: data
    };
}

export { resetgetManualSettlement, getManualSettlement };
